// Set up your root reducer here...
// import { connectRouter } from 'connected-react-router'
import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authReducer";
import checkinReducer from "./checkinReducer";
import appReducer from "./appReducer";
import virReducer from "./virReducer";
import rentalReducer from "./rentalReducer";

/* Redux-Persist */
const createPersistedRootReducer = () =>
  persistCombineReducers(
    {
      key: "root",
      whitelist: ["app", "auth", "checkin", "vir", "rental"],
      storage,
    },
    {
      auth: authReducer,
      checkin: checkinReducer,
      app: appReducer,
      vir: virReducer,
      rental: rentalReducer,
    }
  );

export default createPersistedRootReducer;
